import { render, staticRenderFns } from "./RegisteringSection.vue?vue&type=template&id=e4ab8cd4&scoped=true&"
import script from "./RegisteringSection.vue?vue&type=script&lang=js&"
export * from "./RegisteringSection.vue?vue&type=script&lang=js&"
import style0 from "./RegisteringSection.vue?vue&type=style&index=0&id=e4ab8cd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ab8cd4",
  null
  
)

export default component.exports